import React from "react";
import {KatAccordion, KatAccordionItem} from "@amzn/katal-react";
import {HealthIndicator} from "src/components/healthDashboard/HealthIndicator";
import {Operation} from "src/components/healthDashboard/Operation";
import {IEvent} from "src/context/models/Event";
import {IOperationMetadata} from "src/context/models/Metadata";
import {IOperation, ISectionItem} from "src/context/models/Section";
import {getHighestSevOpenEvent} from "src/common/utils/eventsUtil";
import {EventCard} from "src/components/healthDashboard/EventCard";
import {UpdateEventButton} from "src/components/healthDashboard/editableView/UpdateEventButton";
import {useTranslation} from "react-i18next";
import {capitalizeFirstLetter} from "src/common/utils/commonUtil";
import {isSpectrumHubSite} from "src/common/utils/dashboardUtils";

type Props = {
    section: ISectionItem,
    sectionEventsMap: Map<string, IEvent[]>,
    sectionMetadataMap: Map<string, IOperationMetadata[]>
};

export const Section: React.FC<Props> = ({
                                             section,
                                             sectionEventsMap,
                                             sectionMetadataMap
                                         }) => {
    const {t} = useTranslation();

    const sectionEvents: IEvent[] | undefined = sectionEventsMap.get(section.name);
    const openSectionEvent: IEvent | undefined = getHighestSevOpenEvent(sectionEvents, null);

    const populateOperations = (sectionItem: ISectionItem, operationMetadata: Map<string, IOperationMetadata>) => {
        const operationIdSet: Set<string> = new Set();
        const operationsAcrossVersions: IOperation[] = [];
        Object.keys(sectionItem.versions).forEach((version) => {
            // @ts-ignore
            const operations: IOperation[] = sectionItem.versions[version] as IOperation[];
            operations.map((operation: IOperation) => {
                if (!operationIdSet.has(operation.operationId)) {
                    operationIdSet.add(operation.operationId);
                    operationsAcrossVersions.push(operation);
                }
            });
        })

        return (<KatAccordion className="operations">
            {operationsAcrossVersions.map((operation: IOperation) => {
                    const highestSevOpenEvent: IEvent | undefined = getHighestSevOpenEvent(sectionEvents, operation.operationId);
                    return <Operation key={operation.operationId} operation={operation} openEvent={highestSevOpenEvent}
                                      sectionName={sectionItem.name}
                                      metadata={operationMetadata.get(operation.operationId)}/>
                }
            )}
        </KatAccordion>)
    };

    const operationMetadataMap: Map<string, IOperationMetadata> = new Map<string, IOperationMetadata>();
    sectionMetadataMap.get(section.name)?.forEach(operation =>
        operationMetadataMap.set(operation.operationId, operation));
    return <KatAccordionItem className="section" label={t(capitalizeFirstLetter(section.name))} key={section.name}>
        <HealthIndicator events={sectionEvents} sectionName={section.name}
                         operationId={null}/>
        <div className="section-content">
            {openSectionEvent ?
                <>
                    <EventCard event={openSectionEvent}/>
                    <div className="spacer-xsmall"/>
                </> : null}
            {isSpectrumHubSite() && !openSectionEvent ?
                <>
                    <UpdateEventButton section={section.name}/>
                    <div className="spacer-xsmall"/>
                </> : null}
            {populateOperations(section, operationMetadataMap)}
        </div>
    </KatAccordionItem>
}